import { lazy, Suspense, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { BILLING_ENABLED, FREE_PLACE_LIMIT, useAccessStore } from '@/services/access'
import { getWorldObjectById } from '@/services/landmarks'
const UpgradeGate = lazy(() => import('./UpgradeGate').then((module) => ({ default: module.UpgradeGate })))

export function PlaceAccessBoundary({ children }: { children: React.ReactNode }) {
  const { id } = useParams<{ id: string }>()
  const unlockedPlaceIds = useAccessStore((s) => s.unlockedPlaceIds)
  const hasFullAccess = useAccessStore((s) => s.hasFullAccess)
  const classroomPlaceIds = useAccessStore((s) => s.classroomPlaceIds)
  const entitlementState = useAccessStore((s) => s.entitlementState)
  const unlockPlace = useAccessStore((s) => s.unlockPlace)
  const canClaim = Boolean(id) && unlockedPlaceIds.length < FREE_PLACE_LIMIT
  const allowed = !BILLING_ENABLED || hasFullAccess || Boolean(id && (unlockedPlaceIds.includes(id) || classroomPlaceIds.includes(id))) || canClaim

  useEffect(() => {
    if (BILLING_ENABLED && allowed && id && !hasFullAccess && !classroomPlaceIds.includes(id)) unlockPlace(id)
  }, [allowed, classroomPlaceIds, hasFullAccess, id, unlockPlace])

  if (!allowed && entitlementState === 'loading') return <main className="grid min-h-full place-items-center bg-[#04050f] text-white"><p>Loading account…</p></main>
  return allowed ? <>{children}</> : <Suspense fallback={<div className="min-h-full bg-[#04050f]" />}><UpgradeGate worldObject={id ? getWorldObjectById(id) : undefined} surface="explore" /></Suspense>
}
